export default "__VITE_ASSET__B5QRoLW0__"